// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3EXSH","approved":"Status_approved__25h2u","rejected":"Status_rejected__3zir8","expired":"Status_expired__3wHLP","label":"Status_label__1iaxz"};